<template>
  <div class="p-4">
    <l-container class="mb-4">
      <l-container-title
        slot="toolbar"
        text="Sampling Points"
        icon="network-wired"
        color="bg-pastel-purple"
      />
      <l-csv-import @on-import="onImportSamplingPoints" />
    </l-container>

    <l-csv-export :exportPlugin="exportPlugin" :show="samplingPoints.length > 0" filename="samplingPoints" />

    <hot-table :data="samplingPoints" :settings="settings" ref="hot">
      <hot-column title="ID" data="id" read-only="true"></hot-column>
      <hot-column title="Media Monitored" data="media_monitored_name" read-only="true"></hot-column>
      <hot-column title="Station" data="station" read-only="true"></hot-column>
      <hot-column title="Measurement Regime" data="measurement_regime_name" read-only="true"></hot-column>
      <hot-column title="Mobile" data="mobile" read-only="true"></hot-column>
      <hot-column title="Assessment Type" data="assessment_type_name" read-only="true"></hot-column>
      <hot-column
        title="Station Classification"
        data="station_classification_name"
        read-only="true"
      ></hot-column>
      <hot-column title="Used Aqd" data="used_aqd" read-only="true"></hot-column>
      <hot-column title="Main Emission Sources" data="main_emission_sources" read-only="true"></hot-column>
      <hot-column title="Traffic Emissions" data="traffic_emissions" read-only="true"></hot-column>
      <hot-column title="Heating Emissions" data="heating_emissions" read-only="true"></hot-column>
      <hot-column title="Industrial Emissions" data="industrial_emissions" read-only="true"></hot-column>
      <hot-column title="Distance Source" data="distance_source" read-only="true"></hot-column>
      <hot-column title="Change Aei Stations" data="change_aei_stations" read-only="true"></hot-column>
      <hot-column title="Begin Position" data="begin_position" read-only="true"></hot-column>
      <hot-column title="End Position" data="end_position" read-only="true"></hot-column>
       <hot-column title="Logger ID" data="logger_id" read-only="true"></hot-column>
    </hot-table>
    <l-l-edit
      :showing="edit"
      @save="onSaveSamplingPoints"
      @close="edit = false"
      :samplingPoints="samplingPoints"
      :mediavalues="mediavalues"
      :measurementregimes="measurementregimes"
      :assessmenttypes="assessmenttypes"
      :stationclassifications="stationclassifications"
      :stations="stations"
      :selected="selected"
      :isnew="isnew"
    />
  </div>
</template>

<script>
import ContextMenu from "./context.menu";
import HandsontableHelper from "@/helpers/settings/handsontable";
import "handsontable/dist/handsontable.full.css";
import { HotTable, HotColumn } from "@handsontable/vue";
import Handsontable from "handsontable";
import SamplingpointsService from "./samplingpoints.service";
import LLEdit from "./LLEdit";
import LCsvImport from "@/components/LCsvImport";
import { LInput, LButton } from "@/components/forms";
import Notify from "@/helpers/notify";
import LInfoBox from "@/components/LInfoBox";
import LCsvExport from '@/components/LCsvExport.vue';

export default {
  name: "samplingPoints",
  components: {
    HotTable,
    HotColumn,
    LInput,
    LButton,
    LInfoBox,
    LLEdit,
    LCsvImport,
    LCsvExport
  },
  data() {
    return {
      edit: false,
      loading: false,
      samplingPoints: [],
      mediavalues: [],
      measurementregimes: [],
      assessmenttypes: [],
      stationclassifications: [],
      stations: [],
      settings: HandsontableHelper.settings(false),
      manualSelection: false,
      isnew: false,
      selected: {},
      exportPlugin: {}
    };
  },
  mounted() {
    //this.settings.afterSelectionEnd = this.selectRowOnly;
    this.exportPlugin = this.$refs.hot.hotInstance.getPlugin("exportFile");
    this.settings.dropdownMenu = false;
    this.settings.contextMenu = ContextMenu(this);
    Notify.loadData(null, this.loadInitialData);
  },

  methods: {
    selectRowOnly(r, c, r2, c2) {
      if (this.manualSelection) {
        this.manualSelection = false;
        return;
      }
      const hot = this.$refs.hot.hotInstance;
      hot.deselectCell();
      this.manualSelection = true;
      hot.selectCells([[r, 0, r, hot.countCols() - 1]], false, false);
    },
    async loadInitialData() {
      this.samplingPoints = await SamplingpointsService.samplingpoints();
      this.mediavalues = await SamplingpointsService.mediavalues();
      this.measurementregimes = await SamplingpointsService.measurementregimes();
      this.assessmenttypes = await SamplingpointsService.assessmenttypes();
      this.stationclassifications = await SamplingpointsService.stationclassifications();
      this.stations = await SamplingpointsService.stations();
    },
    // async deleteSamplingPoints(response) {
    //   if (response) {
    //     await Notify.loadData(
    //       "Please wait while data is deleting",
    //       async () => {
    //         const rowsAffected = await SamplingPoints.delete(row.id);
    //         const activeEditor = hot.getActiveEditor();
    //         hot.alter("remove_row", clickedRow, 1);
    //       }
    //     );
    //     Notify.success("Sampling Points deleted!");
    //   }
    // },
    async saveSamplingPoints(ra) {
      const rowsAffected = await SamplingpointsService.update(ra);
      console.log("SAVED TO DB");
      const current = this.samplingPoints.find(n => n.id == ra.id);
      for (var prop in current) {
        if (Object.prototype.hasOwnProperty.call(current, prop)) {
          if (current[prop] != "id" && ra[prop]) {
            current[prop] = ra[prop];
          }
        }
      }
    },
    async importSamplingPoints(file) {
      let formData = new FormData();
      formData.append("csv", file);
      await SamplingpointsService.import(formData);
      this.samplingPoints = await SamplingpointsService.samplingpoints();
      Notify.success("Sampling Points imported!");
    },
    async onImportSamplingPoints(file) {
      await Notify.loadData(
        "Importing sampling points",
        this.importSamplingPoints,
        file
      );
    },
    onEditSamplingPoints(t, o) {
      const clickedRow = o[0].start.row;
      const hot = this.$refs.hot.hotInstance;
      const physicalIndex = hot.toPhysicalRow(clickedRow);
      let row = hot.getSourceDataAtRow(physicalIndex);
      this.selected = row;
      this.isnew = false;
      this.edit = true;
    },
    onNewSamplingPoints(t, o) {
      const hot = this.$refs.hot.hotInstance;
      let row = hot.getSourceDataAtRow(0);
      var newRow = Object.assign({}, row);
      Object.getOwnPropertyNames(newRow).forEach(function(prop) {
        newRow[prop] = null;
      });
      newRow.id = "Id";
      this.selected = newRow;
      this.isnew = true;
      this.edit = true;
    },
    onDeleteSamplingPoints(t, o) {
      const endRow = o[0].end.row;
      const startRow = o[0].start.row;
      const hot = this.$refs.hot.hotInstance;
      // var arrayIds = [];
      // for (let index = startRow; index < endRow+1; index++) {
      //   var row = hot.getDataAtRow(index);
      //   arrayIds.push(row[0]);
      // }

      Notify.prompt(async response => {
        if (response) {
          await Notify.loadData(
            "Please wait while data is deleting",
            async () => {
              for (let index = startRow; index < endRow+1; index++) {
                var row = hot.getDataAtRow(index);
                const rowsAffected = await SamplingpointsService.delete(row[0]);
              }
              const activeEditor = hot.getActiveEditor();
              hot.alter('remove_row', startRow, endRow-startRow+1);
            }
          );
          Notify.success("Sampling Points deleted!");
        }
      }, "This will delete all data connected to this Sampling Point(s). <br/><br/>Do you want to continue?");
      
    },

    async onSaveSamplingPoints(samplingPoint) {
      await Notify.loadData(
        "Saving changes to Sampling Points " + samplingPoint.id,
        this.saveSamplingPoints,
        samplingPoint
      );
      this.selected = {};
    }
  }
};
</script>

